import React from "react";
import { connect } from "react-redux";
import { Link, RouteComponentProps, withRouter } from "react-router-dom";
import { push } from "react-router-redux";
import * as redux from "redux";
import { JobDetailsPartial } from "./JobDetailsPartial";
import * as Actions from "../../../actions";
import * as Comp from "../../../components";
import { Paths } from "../../../constants";
import { CareerCenterStatuses } from "../../../domain";
import * as M from "../../../models";
import { Api } from "../../../services/Api";
import { AppState } from "../../../store";
import { Utility } from "../../../utils";
import { CareerCenterHelper } from "../../../models/careerCenter/CareerCenterHelper";
import { List } from "immutable";

const mapStateToProps = (state: AppState, ownProps: OwnProps | undefined): ConnectedState => ({
    api: new Api(state),
    jobs: state.careerCenter.jobs,
    prevPath: state.router.location && state.router.location.state ? state.router.location.state.prevPath : undefined,
});

const mapDispatchToProps = (dispatch: redux.Dispatch<AppState>): ConnectedDispatch => ({
    goto: (url: string) => dispatch(push(url)),
    notifyError: (message: string, icon?: string) => dispatch(Actions.Noti.notifyError(message, icon)),
});

type OwnProps = RouteComponentProps<{
    slug: string;
    id: string;
}> & {
};

interface ConnectedState {
    api: Api;
    jobs: List<M.CareerCenter.JobPost>;
    prevPath?: string;
}

interface ConnectedDispatch {
    goto: (url: string) => void;
    notifyError: (message: string, icon?: string) => void;
}

interface OwnState {
    invalidRecord: boolean;
    job?: M.CareerCenter.JobPost;
}

class JobDetailsComponent extends Comp.Base.BaseComponent<ConnectedState & ConnectedDispatch & OwnProps, OwnState> {

    public constructor(props: any) {
        super(props);
        this.state = {
            invalidRecord: false,
            loading: true,
        };
    }

    public async componentDidMount() {
        this._isMounted = true;

        const slug = this.props.match.params.slug;
        const id = Utility.getIdFromSlug(slug);
        const slugTitle = this.getSluggedTitle(slug);
        if (!slug || !id) {
            this.props.notifyError("JobPost identifier is missing in URL");
            this.setState({ ...this.state, invalidRecord: true });
            return;
        }

        // get job from state if available
        if (this.props.jobs.size) {
            const job = this.props.jobs.find((x) => x !== undefined && x.id === id);
            if (job) {
                this.setState({ ...this.state, job });
                this.toggleLoading(false);
            }
        }

        const qp = { queryParams: { id } };
        const result = await this.props.api.get<M.CareerCenter.JobPost>(Api.endpoints.careerCenter.job, qp);

        if (!this._isMounted)
            return;

        if (result.isSuccess && result.data) {
            if (result.data.statusId !== CareerCenterStatuses.Active.id) {
                this.props.notifyError("The requested job has been removed or is expired.");
                this.setState({ ...this.state, invalidRecord: true });
                return;
            }

            // make sure slug is correct
            const recordSlug = Utility.toSlug(result.data.title);
            if (recordSlug !== slugTitle)
                this.props.goto(CareerCenterHelper.jobDetailsLink(result.data));

            this.setState({ ...this.state, job: result.data });
        }
        else {
            const errors =  M.Result.Result.errorsOrMessage(result);
            this.props.notifyError(errors.join("<br />"));
            this.setState({ ...this.state, invalidRecord: true });
        }

        this.toggleLoading(false);
    }

    public componentWillUnmount() {
        this._isMounted = false;
    }

    public render() {
        if (this.state.invalidRecord)
            return <Comp.Generic.RedirectWithStatus to={Paths.CareerCenter.JobDirectory} />;

        const job = this.state.job;
        const details = job
            ? <JobDetailsPartial isFullPage job={job} routePath={this.props.match.url} />
            : null;

        return <Comp.Page.PublicPage pageTitle={job && job.title} style={{ minHeight: "200px", position: "relative" }}>
            <Comp.Generic.LoadingSpinner show={this.state.loading} />
            <h1>
                <Link to={Paths.CareerCenter.Landing}>Career Center</Link> &raquo;{" "}
                <Link to={this.props.prevPath || Paths.CareerCenter.JobDirectory}>Search Jobs</Link>
            </h1>

            {details}

            <Comp.Generic.AddThis />
        </Comp.Page.PublicPage>;
    }

    private getSluggedTitle(slug: string) {
        return slug.replace(/(job\-)|((\-\d+)$)/g, "");
    }
}

export const JobDetails: React.ComponentClass<OwnProps> = connect(mapStateToProps, mapDispatchToProps)(withRouter(JobDetailsComponent) as any);



// WEBPACK FOOTER //
// ./src/containers/careerCenter/jobDetails/JobDetails.tsx